import { Button, Col, Form, InputGroup, Modal, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import PhoneInput from "react-phone-input-2";
import es from "react-phone-input-2/lang/es.json";
import { useContext, useEffect, useState } from "react";
import Get from "../../api/Get";
import { authContext } from "../../context/AuthContext";

import "react-phone-input-2/lib/style.css";
import {
  APPOINTMENT_UPDATE,
  COUNTRY_ACTIVE_ALL,
  GET_EPS,
  GET_LOCALIDADES,
  GET_OCUPACION,
  GET_PROPERTY_TYPES,
  GET_ROAD_TYPE,
  LANGUAGE_ACTIVE_ALL,
  MARITAL_STATUS_ALL,
  MUNICIPIO_LIST,
  PACIENTERELACION_GET_ACTIVE,
  PARTNER_GET_ACTIVE_SIN_TOKEN,
  RELIGIONES_ALL,
  STATES_LIST,
  TIPO_DOCUMENTO_PACIENTE_COLOMBIA,
  UPDATE_APPOINTMENT,
} from "../../api/Routes";
import { Field, Formik } from "formik";
import moment from "moment";
import Select from "react-select";
import SimpleLoad from "../../loader/SimpleLoad";
import Put from "../../api/Put";
import ComponentModalErrorSever from "../ComponentModalErrorSever";
import { getTokenExternal } from "../../utils/getTokenExternal";

function ComponentModalPacienteColombia({
  t,
  data,
  showModal,
  handleClose,
  setCita,
}) {
  //console.log(data)
  const { auth } = useContext(authContext);
  const [tipoDocumentoOpt, setTipoDocumentoOpt] = useState([]);
  const [epsDefault, setEpsDefault] = useState(null);
  const [epsOpt, setEpsOpt] = useState([]);
  const [dateOfBirthday, setDateOfBirthday] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [phoneNumber2, setPhoneNumber2] = useState(null);
  const [gender, setGender] = useState("");
  const [tipoSangre, setTipoSangre] = useState("");
  const [countryOpt, setCountryOpt] = useState([]);
  const [countryBirthOpt, setCountryBirthOpt] = useState([]);
  const [paisDefault, setPaisDefault] = useState(null);
  const [idCountry, setIdCountry] = useState(null);
  const [paisNacimientoDefault, setPaisNacimientoDefault] = useState(null);
  const [estadoOpt, setEstadoOpt] = useState([]);
  const [municipioOpt, setMunicipioOpt] = useState([]);
  const [municipioDefault, setMunicipioDefault] = useState(null);
  const [estadoDefault, setEstadoDefault] = useState(null);
  const [locationDefault, setLocationDefault] = useState(null);
  const [idEstado, setIdEstado] = useState(null);
  const [roadTypes, setRoadTypes] = useState([]);
  const [roadTypesDefault, setRoadTypesDefault] = useState(null);
  const [localidadesOpt, setLocalidadesOpt] = useState([]);
  const [propertyTypes, setPropertyTypes] = useState([]);
  const [propertyTypesDefault, setPropertyTypesDefault] = useState(null);
  const [propertyTypesAdicionalDefault, setPropertyTypesAdicionalDefault] =
    useState(null);
  const [ocupacionDefault, setOcupacionDefault] = useState(null);
  const [ocupacionOpt, setOcupacionOpt] = useState([]);
  const [tipoPacientes, setTipoPacientes] = useState([]);
  const [tipoPaciente, setTipoPaciente] = useState("");
  //error server
  const [showModalError, setShowModalError] = useState(false);
  const [errorServer, setErrorServer] = useState(null);
  const handleCloseServer = () => setShowModalError(false);

  const initColombusA = {
    id: "",
    roadType: null,
    streetField1: "",
    streetField2: "",
    streetField3: "",
    propertyNumber: "",
    propertyType: null,
    propertyTypeAdditional: null,
    unitNumber: "",
  };
  const [initialValues, setInitialValues] = useState({
    id: "",
    name: "",
    middleName: "",
    seccondSurname: "",
    lastName: "",
    gender: "",
    dateOfBirthday: "",
    nationality: "",
    externalId: "",
    phoneNumber: "",
    phoneNumber2: "",
    email: "",
    bloodType: "",
    occupacion: {
      id: "",
    },
    address: "",
    peso: "",
    talla: "",
    motivoConsulta: "",
    dayAppointment: "",
    doctorId: "",
    hourDayId: "",
    hourDayHour: "",
    doctorName: "",
    especialidadName: "",
    especialidadId: "",
    account: "",
    currentInsurance: "",
    aceptarTerminos: true,
    ocupacion: {
      id: "",
    },
    localidad: {
      id: "",
    },
    neighborhood: "",
    identityDocumentType: "",
    documentNumber: "",
    choiceType: "",
    patientRelationship: "",
    hourInit: "",
    country: {
      id: "",
    },
    countryBirth: {
      id: "",
    },
    state: null,
    municipio: null,
    colombusAddress: initColombusA,
    documentoTitular: "",
    eps: {
      id: "",
      nombreEps: "",
      codigo: "",
    },
  });
  //console.log(data)
  useEffect(() => {
    //console.log(data)
    if (data) {
      let initColombusA = {
        id: "",
        roadType: data.colombusAddress?.roadType?.id
          ? data.colombusAddress?.roadType
          : null,
        streetField1: data.colombusAddress?.streetField1 ?? "",
        streetField2: data.colombusAddress?.streetField2 ?? "",
        streetField3: data.colombusAddress?.streetField3 ?? "",
        propertyNumber: data.colombusAddress?.propertyNumber ?? "",
        propertyType: data.colombusAddress?.propertyType?.id
          ? data.colombusAddress?.propertyType
          : null,
        propertyTypeAdditional: data.colombusAddress?.propertyTypeAdditional?.id
          ? data.colombusAddress?.propertyTypeAdditional
          : null,
        unitNumber: data.colombusAddress?.unitNumber ?? "",
      };
      let entity = {
        id: data.id,
        name: data.name,
        middleName: data.middleName ?? "",
        seccondSurname: data.seccondSurname ?? "",
        lastName: data.lastName ?? "",
        gender: data.gender ?? "",
        dateOfBirthday: data.dateOfBirthday ?? "",
        nationality: data.nationality,
        phoneNumber: data.phone,
        phoneNumber2: data.phone2,
        email: data.email,
        bloodType: data.bloodType,
        ocupacion: data?.ocupacion ?? null,
        account: data.account,
        neighborhood: data.neighborhood,
        identityDocumentType: data.identityDocumentType?.id ?? "",
        documentNumber: data.documentNumber,
        country: data.country ?? null,
        countryBirth: data.countryBirth ?? null,
        state: data.state ?? null,
        municipio: data.municipio ?? null,
        localidad: data.localidad?.id ? data.localidad : null,
        patientRelationship: data.patientRelationshipDTO?.id ?? "",
        colombusAddress: initColombusA,
        eps: data.eps ?? null,
        peso: data.peso,
        talla: data.talla,
        motivoConsulta: data.motivoConsulta,
      };
      //console.log(entity)
      setDateOfBirthday(
        entity.dateOfBirthday
          ? new Date(moment(entity.dateOfBirthday, "DD-MM-YYYY"))
          : null
      );
      setPhoneNumber(entity.phoneNumber);
      setPhoneNumber2(entity.phoneNumber2 ? entity.phoneNumber2 : "57");
      setGender(entity?.gender ?? "");
      setTipoSangre(entity?.bloodType ?? "");
      setPaisNacimientoDefault({
        value: entity.countryBirth?.id ?? "",
        label: entity.countryBirth?.name,
      });
      setPaisDefault({
        value: entity.country?.id ?? "",
        label: entity.country?.name,
      });
      setIdCountry(entity.country?.id ?? "");
      setEstadoDefault({
        value: entity.state?.id ?? "",
        label: entity.state?.name,
      });
      setIdEstado(entity.state?.id ?? "");
      setMunicipioDefault({
        value: entity.municipio?.id ?? "",
        label: entity.municipio?.dsMunDel,
      });
      setLocationDefault({
        value: entity.localidad?.id ?? "",
        label: entity.localidad?.name,
      });
      setOcupacionDefault({
        value: entity.ocupacion?.id ?? "",
        label: entity.ocupacion?.name,
      });
      setRoadTypesDefault({
        value: entity.colombusAddress?.roadType?.id ?? "",
        label: entity.colombusAddress?.roadType?.name,
      });
      setPropertyTypesDefault(
        entity.colombusAddress?.propertyType?.id
          ? {
              value: entity.colombusAddress?.propertyType?.id,
              label: entity.colombusAddress?.propertyType?.name,
            }
          : null
      );
      setPropertyTypesAdicionalDefault({
        value: entity.colombusAddress?.propertyTypeAdditional?.id ?? "",
        label: entity.colombusAddress?.propertyTypeAdditional?.name,
      });
      setEpsDefault(
        entity.eps
          ? { value: entity.eps?.id ?? "", label: entity.eps?.name }
          : null
      );

      setInitialValues(entity);
    }
  }, [data]);

  useEffect(() => {
    Get({
      url: TIPO_DOCUMENTO_PACIENTE_COLOMBIA,
      access_token: auth.data.access_token,
    })
      .then((response) => {
        setTipoDocumentoOpt(response.data);
      })
      .catch((error) => {
        console.log("error server");
      });
    Get({ url: GET_EPS, access_token: auth.data.access_token })
      .then((response) => {
        if (response.data.state) {
          setEpsOpt(
            response.data.data.response.map((el) => ({
              label: el.nombreEps,
              value: el.id,
            }))
          );
        }
      })
      .catch((error) => {});
  }, []);

  const getTipoDocumento = (value) => {
    let arr = tipoDocumentoOpt
      .filter((el) => el.code === "AS" || el.code === "MS")
      .map((e) => e.id);
    return arr.includes(parseInt(value));
  };
  const [hasLength, setHasLength] = useState(10);
  const getLengthDN = (code) => {
    switch (code.toUpperCase()) {
      case "CE":
        return 12;
      case "CD":
      case "PA":
      case "SC":
        return 16;
      case "PE":
        return 15;
      case "RC":
      case "TI":
        return 11;
      case "CN":
        return 9;
      case "MS":
        return 12;
      default:
        return 10;
    }
  };

  const shemaValidateStepOne = Yup.object().shape({
    name: Yup.string().required(t("Camporequerido")),
    lastName: Yup.string().required(t("Camporequerido")),
    gender: Yup.string().required(t("Camporequerido")),
    dateOfBirthday: Yup.string().required(t("Camporequerido")),
    phoneNumber: Yup.string().required(t("Camporequerido")),
    phoneNumber2: Yup.string().required(t("Camporequerido")),
    email: Yup.string()
      .email(t("Correoinvalido"))
      .matches(/^(?!prueba@prueba.com\b)/i, "Este correo no se puede usar")
      .required(t("Camporequerido")),
    identityDocumentType: Yup.string().required(t("Camporequerido")),
    documentNumber: Yup.string().when("identityDocumentType", {
      is: (value) => getTipoDocumento(value),
      then: Yup.string().required(t("Camporequerido")),
      otherwise: Yup.string()
        .required(t("Camporequerido"))
        .min(5, `Debe tener una longitud mínima de 5 caracteres`)
        .max(
          hasLength,
          `Debe tener una longitud máxima de ${hasLength} caracteres`
        ),
    }),
    country: Yup.object().shape({
      id: Yup.string().required(t("Camporequerido")),
    }),
    countryBirth: Yup.object().shape({
      id: Yup.string().required(t("Camporequerido")),
    }),
    //municipio: Yup.object().shape({id: Yup.string().required(t('Camporequerido')),}),
    localidad: Yup.object()
      .when("municipio", {
        is: (value) => value?.id == "2633",
        then: Yup.object().required(t("Camporequerido")),
      })
      .nullable(),
    //state: Yup.object().shape({id: Yup.string().required(t('Camporequerido')),}),
    ocupacion: Yup.object().shape({
      id: Yup.string().required(t("Camporequerido")),
    }),
    nationality: Yup.string().required(t("Camporequerido")),
    bloodType: Yup.string().required(t("Camporequerido")),
    peso: Yup.number()
      .required(t("Camporequerido"))
      .positive(t("mayor_a_cero")),
    talla: Yup.number()
      .required(t("Camporequerido"))
      .positive(t("mayor_a_cero")),
    motivoConsulta: Yup.string().required(t("Camporequerido")),
    patientRelationship: Yup.string().required(t("Camporequerido")),
    colombusAddress: Yup.object().shape({
      roadType: Yup.object().shape({
        id: Yup.string().required(t('Camporequerido')),
      }),
      streetField1: Yup.string().required(t('Camporequerido')),
      streetField2: Yup.string().required(t('Camporequerido')),
      streetField3: Yup.string().required(t('Camporequerido')),
      propertyTypeAdditional: Yup.object().shape({
        id: Yup.string().required(t('Camporequerido')),
      }),
      propertyNumber: Yup.string().required(t('Camporequerido')),
      propertyType: Yup.object().shape({
        id: Yup.string().required(t('Camporequerido')),
      }),
      unitNumber: Yup.string().required(t('Camporequerido')),
    }),
    eps: Yup.object().when("account", {
      is: (value) => value && value.id === 144,
      then: Yup.object().shape({
        id: Yup.string(),
      }),
      otherwise: Yup.object().shape({
        id: Yup.number().required(t("Camporequerido")),
      }),
    }),
    neighborhood: Yup.string().required(t("Camporequerido")),
  });

  useEffect(() => {
    if (data) {
      Get({ url: TIPO_DOCUMENTO_PACIENTE_COLOMBIA, noToken: true })
        .then((response) => {
          setTipoDocumentoOpt(response.data);
        })
        .catch((error) => {
          setShowModalError(true);
          if (error.response) {
            setErrorServer(error.response);
          }
        });

      Get({ url: COUNTRY_ACTIVE_ALL, noToken: true })
        .then((response) => {
          setCountryOpt(
            response.data.data.response.map((el) => ({
              label: el.name,
              value: el.id,
            }))
          );
          setCountryBirthOpt(
            response.data.data.response.map((el) => ({
              label: el.name,
              value: el.id,
            }))
          );
        })
        .catch((error) => {
          setShowModalError(true);
          if (error.response) {
            setErrorServer(error.response);
          }
        });
      Get({
        url: `${PARTNER_GET_ACTIVE_SIN_TOKEN}/${data.account.id}`,
        noToken: true,
      })
        .then((response) => {
          setTipoPacientes(response.data.data.response);
        })
        .catch((error) => {
          setShowModalError(true);
          if (error.response) {
            setErrorServer(error.response);
          }
        });
      //direccion de clb
      getTokenExternal(
        data.company ? data.company : data.account.partner.company
      ).then((response) => {
        Get({ url: GET_ROAD_TYPE, access_token: response.data.access_token })
          .then((response) => {
            setRoadTypes(response.data.data.response);
          })
          .catch((error) => {
            setShowModalError(true);
            if (error.response) {
              setErrorServer(error.response);
            }
          });
        Get({
          url: GET_PROPERTY_TYPES,
          access_token: response.data.access_token,
        })
          .then((response) => {
            setPropertyTypes(response.data.data.response);
          })
          .catch((error) => {
            setShowModalError(true);
            if (error.response) {
              setErrorServer(error.response);
            }
          });

        //localidades
        Get({ url: GET_LOCALIDADES, access_token: response.data.access_token })
          .then((response) => {
            if (response.data.state) {
              setLocalidadesOpt(
                response.data.data.response.map((el) => ({
                  label: el.nombreLocalidad,
                  value: el.id,
                }))
              );
            }
          })
          .catch((error) => {
            setShowModalError(true);
            if (error.response) {
              setErrorServer(error.response);
            }
          });
        //ocupacion
        Get({ url: GET_OCUPACION, access_token: response.data.access_token })
          .then((response) => {
            if (response.data.state) {
              setOcupacionOpt(
                response.data.data.response.map((el) => ({
                  label: el.nombreOcupacion,
                  value: el.id,
                }))
              );
            }
          })
          .catch((error) => {
            setShowModalError(true);
            if (error.response) {
              setErrorServer(error.response);
            }
          });
        //eps
        Get({ url: GET_EPS, access_token: response.data.access_token })
          .then((response) => {
            //console.log(response)
            if (response.data.state) {
              setEpsOpt(
                response.data.data.response.map((el) => ({
                  label: el.nombreEps,
                  value: el.id,
                }))
              );
            }
          })
          .catch((error) => {
            setShowModalError(true);
            if (error.response) {
              setErrorServer(error.response);
            }
          });
      });
    }
  }, [data]);

  useEffect(() => {
    if (idCountry) {
      Get({ url: `${STATES_LIST}/${idCountry}`, noToken: true })
        .then((response) => {
          //console.log(response)
          setEstadoOpt(
            response.data.data.response.map((el) => ({
              label: el.name,
              value: el.id,
            }))
          );
        })
        .catch((error) => {
          setEstadoOpt([]);
        });
    } else {
      setEstadoOpt([]);
    }
  }, [idCountry]);

  useEffect(() => {
    if (idEstado) {
      Get({ url: `${MUNICIPIO_LIST}/${idEstado}`, noToken: true })
        .then((response) => {
          //console.log(response)
          setMunicipioOpt(
            response.data.data.response.map((el) => ({
              label: el.dsMunDel,
              value: el.id,
            }))
          );
        })
        .catch((error) => {
          setMunicipioOpt([]);
        });
    } else {
      setMunicipioOpt([]);
    }
  }, [idEstado]);

  return (
    <>
      <Modal
        show={showModal}
        size="lg"
        onHide={handleClose}
        dialogClassName="modal-90w"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body className="px-3 overflow-hidden">
          <Formik
            initialValues={initialValues}
            validationSchema={shemaValidateStepOne}
            enableReinitialize
            onSubmit={(values, { setSubmitting, setFieldValue }) => {
              //console.log(values)
              let apptoUpdate = {
                id: data.idCita,
                peso: values.peso,
                talla: values.talla,
                motivoConsulta: values.motivoConsulta,
                patient: {
                  // id: data.idPatient,
                  // name: values.name,
                  // middleName: values.middleName,
                  // seccondSurname: values.seccondSurname,
                  // lastName: values.lastName,
                  // phoneNumber: values.phoneNumber,
                  // phoneNumber2: values.phoneNumber2,
                  // email: values.email,
                  // identityDocumentType: {id: values.identityDocumentType},
                  // documentNumber: values.documentNumber,
                  // dateOfBirthday: moment(dateOfBirthday).format('DD-MM-YYYY'),
                  // eps: {
                  //     id: epsDefault.value,
                  // }
                  ...values,
                  ocupacion: {
                    id: values.ocupacion.id,
                    name:
                      ocupacionOpt.find((o) => o.value == values.ocupacion.id)
                        ?.label ?? "",
                  },
                  dateOfBirthday: moment(dateOfBirthday).format("DD-MM-YYYY"),
                  identityDocumentType: { id: values.identityDocumentType },
                  patientRelationship: { id: values.patientRelationship },
                },
              };
              console.log(apptoUpdate);

              Put({
                url: APPOINTMENT_UPDATE,
                data: apptoUpdate,
                access_token: auth.data.access_token,
                header: true,
              })
                .then((response) => {
                  console.log(response);
                  setSubmitting(false);
                  setCita((prev) => ({
                    ...prev,
                    ageDTO: response.data.data.ageDTO,
                    peso: response.data.data.peso,
                    talla: response.data.data.talla,
                    motivoConsulta: response.data.data.motivoConsulta,
                    patientDTO: {
                      ...response.data.data.patientDTO,
                      ocupacion: {
                        id: values.ocupacion.id,
                        name:
                          ocupacionOpt.find(
                            (o) => o.value == values.ocupacion.id
                          )?.label ?? "",
                      },
                    },
                  }));
                  handleClose();
                })
                .catch((error) => {
                  setSubmitting(false);
                  setShowModalError(true);
                  setErrorServer(error?.response);
                });
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
              setFieldError,
            }) => (
              <Form onSubmit={handleSubmit}>
                {/* {console.log(errors)}
                            {console.log(values)} */}
                {isSubmitting && <SimpleLoad />}
                <h4 className="text-color-4">Actualizar información</h4>
                <Row>
                  <Col xs="12" md="3">
                    <Form.Group>
                      <Form.Label>
                        Tipo documento <span className="text-danger">*</span>
                      </Form.Label>
                      <Field
                        as="select"
                        className={`form-control input-form ${
                          errors.identityDocumentType && "error"
                        }`}
                        name="identityDocumentType"
                        onChange={(e) => {
                          if (e.target.value !== "") {
                            let ide = tipoDocumentoOpt.filter(
                              (el) => el.id === parseInt(e.target.value)
                            )[0];
                            setFieldValue(
                              "identityDocumentType",
                              parseInt(e.target.value)
                            );
                            setHasLength(getLengthDN(ide.code));
                          } else {
                            setFieldValue(
                              "identityDocumentType",
                              e.target.value
                            );
                          }
                        }}
                      >
                        <option value="">{t("Seleccionar")}</option>
                        {tipoDocumentoOpt.map((item, i) => (
                          <option
                            value={item.id}
                            key={i}
                          >{`${item.code} : ${item.name}`}</option>
                        ))}
                      </Field>
                      {errors.identityDocumentType && (
                        <div className="invalid-feedback d-block">
                          {errors.identityDocumentType}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs="12" md="3">
                    <Form.Group>
                      <Form.Label>
                        No. documento <span className="text-danger">*</span>
                      </Form.Label>
                      <Field
                        type="text"
                        className={`form-control input-form ${
                          errors.documentNumber && "error"
                        }`}
                        name="documentNumber"
                      />
                      {errors.documentNumber && (
                        <div className="invalid-feedback d-block">
                          {errors.documentNumber}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs="12" md="3">
                    <Form.Group>
                      <Form.Label>
                        Tipo paciente <span className="text-danger">*</span>
                      </Form.Label>
                      <Field
                        as="select"
                        className={`form-control input-form ${
                          errors.patientRelationship && "error"
                        }`}
                        name="patientRelationship"
                        onChange={(e) => {
                          if (e.target.value) {
                            setFieldValue(
                              "patientRelationship",
                              e.target.value
                            );
                          } else {
                            setFieldValue("patientRelationship", "");
                          }
                          setTipoPaciente(e.target.value);
                          //setCopyValues({...values, patientRelationship: e.target.value});
                        }}
                      >
                        <option value="">Seleccionar</option>
                        {tipoPacientes.map((item, i) => (
                          <option key={i} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </Field>
                      {errors.patientRelationship && (
                        <div className="invalid-feedback d-block">
                          {errors.patientRelationship}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  {console.log(values)}
                  {values.patientRelationship &&
                    values.patientRelationship != "1" &&
                    values.account.id === 68 && (
                      <Col xs="12" md="3">
                        <Form.Group>
                          <Form.Label>
                            Número de documento del titular{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Field
                            className={`form-control input-form ${
                              errors.titular?.documentNumber && "error"
                            }`}
                            name="titular.documentNumber"
                          />
                          {errors.titular?.documentNumber && (
                            <div className="invalid-feedback d-block">
                              {errors.titular?.documentNumber}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                    )}
                  <Col xs="12" md="3">
                    <Form.Group>
                      <Form.Label className="font-weight-bold-600 text-secondary">
                        Ocupación <span className="text-danger">*</span>
                      </Form.Label>
                      <Select
                        className={`input-form ${errors.ocupacion && "error"}`}
                        options={ocupacionOpt}
                        defaultValue={ocupacionDefault}
                        value={ocupacionDefault}
                        onChange={(value) => {
                          //console.log(value)
                          setOcupacionDefault(value);
                          if (value) {
                            setFieldValue("ocupacion.id", value.value);
                          } else {
                            setFieldValue("ocupacion.id", "");
                          }
                        }}
                        placeholder="Escoger opción"
                      />
                      {errors.ocupacion && (
                        <div className="invalid-feedback d-block">
                          {t("Camporequerido")}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs="12" md="3">
                    <Form.Group>
                      <Form.Label>
                        Nombre <span className="text-danger">*</span>
                      </Form.Label>
                      <Field
                        type="text"
                        className={`form-control input-form text-uppercase ${
                          errors.name && "error"
                        }`}
                        name="name"
                        onChange={(e) => {
                          setFieldValue("name", e.target.value.toUpperCase());
                        }}
                      />
                      {errors.name && (
                        <div className="invalid-feedback d-block">
                          {errors.name}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs="12" md="3">
                    <Form.Group>
                      <Form.Label>Segundo nombre</Form.Label>
                      <Field
                        type="text"
                        className={`form-control input-form text-uppercase`}
                        name="middleName"
                        onChange={(e) => {
                          setFieldValue(
                            "middleName",
                            e.target.value.toUpperCase()
                          );
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs="12" md="3">
                    <Form.Group>
                      <Form.Label>
                        Primer apellido <span className="text-danger">*</span>
                      </Form.Label>
                      <Field
                        type="text"
                        className={`form-control input-form text-uppercase ${
                          errors.lastName && "error"
                        }`}
                        name="lastName"
                        onChange={(e) => {
                          setFieldValue(
                            "lastName",
                            e.target.value.toUpperCase()
                          );
                        }}
                      />
                      {errors.lastName && (
                        <div className="invalid-feedback d-block">
                          {errors.lastName}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs="12" md="3">
                    <Form.Group>
                      <Form.Label>Segundo apellido</Form.Label>
                      <Field
                        type="text"
                        className={`form-control input-form text-uppercase`}
                        name="seccondSurname"
                        onChange={(e) => {
                          setFieldValue(
                            "seccondSurname",
                            e.target.value.toUpperCase()
                          );
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs="12" md="3">
                    <Form.Group>
                      <Form.Label>
                        Correo electrónico{" "}
                        <span className="text-danger">*</span>
                      </Form.Label>
                      <Field
                        type="text"
                        className={`form-control input-form ${
                          errors.email && "error"
                        }`}
                        name="email"
                      />
                      {errors.email && (
                        <div className="invalid-feedback d-block">
                          {errors.email}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs="12" md="3">
                    <Form.Group>
                      <Form.Label>
                        Teléfono <span className="text-danger">*</span>
                      </Form.Label>
                      <PhoneInput
                        inputClass={`form-control input-form ${
                          errors.phoneNumber && "error"
                        } w-100`}
                        country={"co"}
                        countryCodeEditable={false}
                        enableSearch={true}
                        preferredCountries={["co", "mx"]}
                        disableSearchIcon={true}
                        localization={es}
                        value={phoneNumber}
                        onChange={(phone, country, e, formattedValue) => {
                          //console.log(phone)
                          setPhoneNumber(phone);
                          setFieldValue("phoneNumber", phone);
                          let validNumber = country.format.match(/\./g).length;
                          if (phone.length !== validNumber) {
                            setFieldError("phoneNumber", "Campo inválido");
                          } else if (phone.length === validNumber) {
                            setFieldValue("phoneNumber", phone, true);
                          }
                        }}
                      />
                      {errors.phoneNumber && (
                        <div className="invalid-feedback d-block">
                          {errors.phoneNumber}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs="12" md="3">
                    <Form.Group>
                      <Form.Label>
                        Teléfono alterno <span className="text-danger">*</span>
                      </Form.Label>
                      <PhoneInput
                        inputClass={`form-control input-form ${
                          errors.phoneNumber2 && "error"
                        } w-100`}
                        country={"co"}
                        countryCodeEditable={false}
                        enableSearch={true}
                        preferredCountries={["co", "mx"]}
                        disableSearchIcon={true}
                        localization={es}
                        value={phoneNumber2}
                        onChange={(phone, country, e, formattedValue) => {
                          //console.log(phone)
                          setPhoneNumber2(phone);
                          setFieldValue("phoneNumber2", phone);
                          let validNumber = country.format.match(/\./g).length;
                          if (phone.length !== validNumber) {
                            setFieldError("phoneNumber2", "Campo inválido");
                          } else if (phone.length === validNumber) {
                            setFieldValue("phoneNumber2", phone, true);
                          }
                        }}
                      />
                      {errors.phoneNumber2 && (
                        <div className="invalid-feedback d-block">
                          {errors.phoneNumber2}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs="12" md="3">
                    <Form.Group>
                      <Form.Label className="font-weight-bold-600 text-secondary">
                        Sexo <span className="text-danger">*</span>
                      </Form.Label>
                      <ul className="mb-0 list-inline list-form">
                        <li
                          className={`${
                            gender === "Female" && "active"
                          } list-inline-item cursor-pointer`}
                          onClick={(e) => {
                            setGender("Female");
                            setFieldValue("gender", "Female");
                          }}
                        >
                          <span className="input-radio-custom text-color-input">
                            {t("Femenino")}
                          </span>
                        </li>
                        <li
                          className={`${
                            gender === "Male" && "active"
                          } list-inline-item cursor-pointer`}
                          onClick={(e) => {
                            setGender("Male");
                            setFieldValue("gender", "Male");
                          }}
                        >
                          <span className="input-radio-custom text-color-input">
                            {t("Masculino")}
                          </span>
                        </li>
                        <li
                          className={`${
                            gender === "NotSpecified" && "active"
                          } list-inline-item cursor-pointer`}
                          onClick={(e) => {
                            setGender("NotSpecified");
                            setFieldValue("gender", "NotSpecified");
                          }}
                        >
                          <span className="input-radio-custom text-color-input">
                            No especificado
                          </span>
                        </li>
                      </ul>
                      {errors.gender && (
                        <div className="invalid-feedback d-block">
                          {errors.gender}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs="12" md="3">
                    <Form.Group>
                      <Form.Label>
                        Fecha nacimiento <span className="text-danger">*</span>
                      </Form.Label>
                      <DatePicker
                        className={`form-control input-form w-100 ${
                          errors.dateOfBirthday && "error"
                        }`}
                        selected={dateOfBirthday}
                        dateFormat="dd-MM-yyyy"
                        maxDate={new Date()}
                        onChange={(date) => {
                          if (date === null) {
                            setDateOfBirthday(null);
                            setFieldValue("dateOfBirthday", "");
                          } else {
                            setDateOfBirthday(date);
                            setFieldValue("dateOfBirthday", date);
                          }
                        }}
                      />
                      {errors.dateOfBirthday && (
                        <div className="invalid-feedback d-block">
                          {errors.dateOfBirthday}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs="12" md="3">
                    <Form.Group>
                      <Form.Label>
                        Entidad Promotora de Salud (EPS){" "}
                        <span className="text-danger">*</span>
                      </Form.Label>
                      <Select
                        className={`input-form ${errors.eps && "error"}`}
                        options={epsOpt}
                        defaultValue={epsDefault}
                        value={epsDefault}
                        onChange={(value) => {
                          //console.log(value)
                          setEpsDefault(value);
                          setFieldValue("eps.id", value.value);
                        }}
                        placeholder="Escoger opción"
                      />
                      {errors.eps?.id && (
                        <div className="invalid-feedback d-block">
                          {errors.eps?.id}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs="12" md="5">
                    <Form.Group>
                      <Form.Label className="font-weight-bold-600 text-secondary">
                        Tipo sangre <span className="text-danger">*</span>
                      </Form.Label>
                      <ul className="mb-0 list-inline list-form">
                        <li
                          className={`${
                            tipoSangre === "O-" && "active"
                          } list-inline-item cursor-pointer`}
                          onClick={(e) => {
                            setTipoSangre("O-");
                            setFieldValue("bloodType", "O-");
                          }}
                        >
                          <span className="input-radio-custom text-color-input">
                            O-
                          </span>
                        </li>
                        <li
                          className={`${
                            tipoSangre === "O+" && "active"
                          } list-inline-item cursor-pointer`}
                          onClick={(e) => {
                            setTipoSangre("O+");
                            setFieldValue("bloodType", "O+");
                          }}
                        >
                          <span className="input-radio-custom text-color-input">
                            O+
                          </span>
                        </li>
                        <li
                          className={`${
                            tipoSangre === "A-" && "active"
                          } list-inline-item cursor-pointer`}
                          onClick={(e) => {
                            setTipoSangre("A-");
                            setFieldValue("bloodType", "A-");
                          }}
                        >
                          <span className="input-radio-custom text-color-input">
                            A-
                          </span>
                        </li>
                        <li
                          className={`${
                            tipoSangre === "A+" && "active"
                          } list-inline-item cursor-pointer`}
                          onClick={(e) => {
                            setTipoSangre("A+");
                            setFieldValue("bloodType", "A+");
                          }}
                        >
                          <span className="input-radio-custom text-color-input">
                            A+
                          </span>
                        </li>
                        <li
                          className={`${
                            tipoSangre === "AB-" && "active"
                          } list-inline-item cursor-pointer`}
                          onClick={(e) => {
                            setTipoSangre("AB-");
                            setFieldValue("bloodType", "AB-");
                          }}
                        >
                          <span className="input-radio-custom text-color-input">
                            AB-
                          </span>
                        </li>
                        <li
                          className={`${
                            tipoSangre === "AB+" && "active"
                          } list-inline-item cursor-pointer`}
                          onClick={(e) => {
                            setTipoSangre("AB+");
                            setFieldValue("bloodType", "AB+");
                          }}
                        >
                          <span className="input-radio-custom text-color-input">
                            AB+
                          </span>
                        </li>
                        <li
                          className={`${
                            tipoSangre === "B+" && "active"
                          } list-inline-item cursor-pointer`}
                          onClick={(e) => {
                            setTipoSangre("B+");
                            setFieldValue("bloodType", "B+");
                          }}
                        >
                          <span className="input-radio-custom text-color-input">
                            B+
                          </span>
                        </li>
                        <li
                          className={`${
                            tipoSangre === "B-" && "active"
                          } list-inline-item cursor-pointer`}
                          onClick={(e) => {
                            setTipoSangre("B-");
                            setFieldValue("bloodType", "B-");
                          }}
                        >
                          <span className="input-radio-custom text-color-input">
                            B-
                          </span>
                        </li>
                        <li
                          className={`${
                            tipoSangre === "desconocido" && "active"
                          } list-inline-item cursor-pointer`}
                          onClick={(e) => {
                            setTipoSangre("desconocido");
                            setFieldValue("bloodType", "desconocido");
                          }}
                        >
                          <span className="input-radio-custom text-color-input">
                            {t("Desconocido")}
                          </span>
                        </li>
                      </ul>
                      {errors.bloodType && (
                        <div className="invalid-feedback d-block">
                          {errors.bloodType}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs="12" md="4">
                    <Form.Group>
                      <Form.Label className="font-weight-bold-600 text-secondary">
                        Nacionalidad <span className="text-danger">*</span>
                      </Form.Label>
                      <div className="mt-3">
                        <label className="mr-5 text-color-input">
                          {t("colombiana")}
                          <Field
                            type="radio"
                            name="nationality"
                            value="Colombiana"
                            className="ml-3 radio-form"
                            onChange={(e) => {
                              setFieldValue("nationality", "Colombiana");
                              let p = countryOpt.filter(
                                (el) => el.label.toLowerCase() === "colombia"
                              );
                              if (p.length > 0) {
                                setFieldValue("country.id", p[0].value);
                                setPaisDefault({
                                  label: p[0].label,
                                  value: p[0].value,
                                });
                                setIdCountry(p[0].value);

                                setFieldValue("countryBirth.id", p[0].value);
                                setPaisNacimientoDefault({
                                  label: p[0].label,
                                  value: p[0].value,
                                });
                              }
                            }}
                          />
                        </label>
                        <label className="mr-5 text-color-input">
                          {t("Extranjera")}
                          <Field
                            type="radio"
                            name="nationality"
                            value="Extranjera"
                            className="ml-3 radio-form"
                          />
                        </label>
                      </div>
                      {errors.nationality && (
                        <div className="invalid-feedback d-block">
                          {errors.nationality}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs="12" md="3">
                    <Form.Group>
                      <Form.Label className="font-weight-bold-600 text-secondary">
                        País de nacimiento{" "}
                        <span className="text-danger">*</span>
                      </Form.Label>
                      <Select
                        className={`input-form ${
                          errors.countryBirth && "error"
                        }`}
                        options={countryBirthOpt}
                        defaultValue={paisNacimientoDefault}
                        value={paisNacimientoDefault}
                        onChange={(value) => {
                          //console.log(value)
                          setPaisNacimientoDefault(value);
                          setFieldValue("countryBirth.id", value.value);
                        }}
                        placeholder="Escoger opción"
                        isDisabled={values.nationality === "Colombiana"}
                      />
                      {errors.countryBirth && (
                        <div className="invalid-feedback d-block">
                          {t("Camporequerido")}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs="12" md="3">
                    <Form.Group>
                      <Form.Label className="font-weight-bold-600 text-secondary">
                        País de residencia{" "}
                        <span className="text-danger">*</span>
                      </Form.Label>
                      <Select
                        className={`input-form ${errors.country && "error"}`}
                        options={countryOpt}
                        defaultValue={paisDefault}
                        value={paisDefault}
                        onChange={(value) => {
                          //console.log(e)
                          setPaisDefault(value);
                          setFieldValue("country.id", value.value);
                          setMunicipioOpt([]);
                          setFieldValue("municipio", null);
                          setMunicipioDefault(null);
                          setFieldValue("state", null);
                          setEstadoDefault(null);
                          setIdCountry(value.value);
                        }}
                        placeholder="Escoger opción"
                      />
                      {errors.country && (
                        <div className="invalid-feedback d-block">
                          {t("Camporequerido")}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs="12" md="3">
                    <Form.Group>
                      <Form.Label className="font-weight-bold-600 text-secondary">
                        {t("departamento")}{" "}
                        <span className="text-danger">*</span>
                      </Form.Label>
                      <Select
                        className={`input-form ${errors.state && "error"}`}
                        options={estadoOpt}
                        defaultValue={estadoDefault}
                        value={estadoDefault}
                        onChange={(value) => {
                          //console.log(e)
                          setEstadoDefault(value);
                          setFieldValue("state.id", value.value);
                          setFieldValue("municipio", null);
                          setFieldValue("localidad", null);
                          setMunicipioDefault(null);
                          setLocationDefault(null);
                          setMunicipioOpt([]);
                          setIdEstado(value.value);
                        }}
                        placeholder="Escoger opción"
                      />
                      {errors.state && (
                        <div className="invalid-feedback d-block">
                          {errors.state}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs="12" md="3">
                    <Form.Group>
                      <Form.Label className="font-weight-bold-600 text-secondary">
                        Ciudad <span className="text-danger">*</span>
                      </Form.Label>
                      <Select
                        className={`input-form ${errors.municipio && "error"}`}
                        options={municipioOpt}
                        defaultValue={municipioDefault}
                        value={municipioDefault}
                        onChange={(value) => {
                          //console.log(value)
                          setMunicipioDefault(value);
                          setFieldValue("municipio.id", value.value);
                          if (value.value !== "2633") {
                            setFieldValue("localidad", null);
                          }
                        }}
                        placeholder="Escoger opción"
                      />
                      {errors.municipio && (
                        <div className="invalid-feedback d-block">
                          {t("Camporequerido")}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs="12" md="3">
                    <Form.Group>
                      <Form.Label className="font-weight-bold-600 text-secondary">
                        Tipo de calle <span className="text-danger">*</span>
                      </Form.Label>
                      <Select
                        className={`input-form ${
                          errors.colombusAddress?.roadType && "error"
                        }`}
                        options={roadTypes?.map((e) => ({
                          label: e.name,
                          value: e.id,
                        }))}
                        defaultValue={roadTypesDefault}
                        value={roadTypesDefault}
                        onChange={(e) => {
                          //console.log(e)
                          setRoadTypesDefault(e);
                          setFieldValue("colombusAddress.roadType.id", e.value);
                        }}
                        placeholder="Escoger opción"
                      />
                      {errors.colombusAddress?.roadType && (
                        <div className="invalid-feedback d-block">
                          {t("Camporequerido")}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs="12" md="2">
                    <Form.Label className="font-weight-bold-600 text-secondary opacity-0">
                      {" "}
                      <span className="text-danger">No *</span>
                    </Form.Label>
                    <Field
                      type="text"
                      className={`form-control input-form ${
                        errors.colombusAddress?.streetField1 && "error"
                      }`}
                      name="colombusAddress.streetField1"
                    />
                    {errors.colombusAddress?.streetField1 && (
                      <div className="invalid-feedback d-block">
                        {errors.colombusAddress.streetField1}
                      </div>
                    )}
                  </Col>
                  <Col xs="12" md="2">
                    <Form.Label className="font-weight-bold-600 text-secondary">
                      Número <span className="text-danger">*</span>
                    </Form.Label>
                    <InputGroup>
                      <InputGroup.Text className="border-right-0 rounded-0 input-group-text-rounded-0">
                        #
                      </InputGroup.Text>
                      <Field
                        type="text"
                        className={`form-control input-form ${
                          errors.colombusAddress?.streetField2 && "error"
                        }`}
                        name="colombusAddress.streetField2"
                      />
                    </InputGroup>
                    {errors.colombusAddress?.streetField2 && (
                      <div className="invalid-feedback d-block">
                        {errors.colombusAddress.streetField2}
                      </div>
                    )}
                  </Col>
                  <Col xs="12" md="2">
                    <Form.Label className="font-weight-bold-600 text-secondary opacity-0">
                      Número <span className="text-danger">*</span>
                    </Form.Label>
                    <InputGroup>
                      <InputGroup.Text className="border-right-0 rounded-0 input-group-text-rounded-0">
                        -
                      </InputGroup.Text>
                      <Field
                        type="text"
                        className={`form-control input-form ${
                          errors.colombusAddress?.streetField3 && "error"
                        }`}
                        name="colombusAddress.streetField3"
                      />
                    </InputGroup>
                    {errors.colombusAddress?.streetField3 && (
                      <div className="invalid-feedback d-block">
                        {errors.colombusAddress.streetField3}
                      </div>
                    )}
                  </Col>
                  <Col xs="12" md="4">
                    <Form.Group>
                      <Form.Label>
                        Localidad <span className="text-danger">*</span>
                      </Form.Label>
                      <Select
                        className={`input-form ${errors.localidad && "error"}`}
                        options={localidadesOpt}
                        defaultValue={locationDefault}
                        value={locationDefault}
                        onChange={(value) => {
                          setLocationDefault(value);
                          setFieldValue("localidad.id", value.value);
                        }}
                        placeholder="Escoger opción"
                      />
                      {errors.localidad && (
                        <div className="invalid-feedback d-block">
                          {t("Camporequerido")}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs="12" md="4">
                    <Form.Group>
                      <Form.Label>
                        Barrio <span className="text-danger">*</span>
                      </Form.Label>
                      <Field
                        type="text"
                        className={`form-control input-form ${
                          errors.neighborhood && "error"
                        }`}
                        name="neighborhood"
                      />
                      {errors.neighborhood && (
                        <div className="invalid-feedback d-block">
                          {errors.neighborhood}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs="12" md="12"></Col>
                  <Col xs="12" md="4">
                    <Form.Group>
                      <Form.Label>
                        Tipo de Inmueble <span className="text-danger">*</span>
                      </Form.Label>
                      <Select
                        className={`input-form ${
                          errors.colombusAddress?.propertyType && "error"
                        }`}
                        options={propertyTypes?.map((e) => ({
                          label: e.name,
                          value: e.id,
                        }))}
                        defaultValue={propertyTypesDefault}
                        value={propertyTypesDefault}
                        onChange={(e) => {
                          //console.log(e)
                          setPropertyTypesDefault(e);
                          setFieldValue(
                            "colombusAddress.propertyType.id",
                            e.value
                          );
                        }}
                        placeholder="Escoger opción"
                      />
                      {errors.colombusAddress?.propertyType && (
                        <div className="invalid-feedback d-block">
                          {t("Camporequerido")}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs="12" md="2">
                    <Form.Label>
                      {" "}
                      No. <span className="text-danger">*</span>
                    </Form.Label>
                    <Field
                      type="text"
                      className={`form-control input-form ${
                        errors.colombusAddress?.unitNumber && "error"
                      }`}
                      name="colombusAddress.unitNumber"
                    />
                    {errors.colombusAddress?.unitNumber && (
                      <div className="invalid-feedback d-block">
                        {errors.colombusAddress?.unitNumber}
                      </div>
                    )}
                  </Col>
                  <Col xs="12" md="4">
                    <Form.Group>
                      <Form.Label className="font-weight-bold-600 text-secondary">
                        Bloque o Interior <span className="text-danger">*</span>
                      </Form.Label>
                      <Select
                        className={`input-form ${
                          errors.colombusAddress?.propertyTypeAdditional &&
                          "error"
                        }`}
                        options={propertyTypes?.map((e) => ({
                          label: e.name,
                          value: e.id,
                        }))}
                        defaultValue={propertyTypesAdicionalDefault}
                        value={propertyTypesAdicionalDefault}
                        onChange={(e) => {
                          //console.log(e)
                          setPropertyTypesAdicionalDefault(e);
                          setFieldValue(
                            "colombusAddress.propertyTypeAdditional.id",
                            e.value
                          );
                        }}
                        placeholder="Escoger opción"
                      />
                      {errors.colombusAddress?.propertyTypeAdditional && (
                        <div className="invalid-feedback d-block">
                          {t("Camporequerido")}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs="12" md="2">
                    <Form.Label className="font-weight-bold-600 text-secondary">
                      No. <span className="text-danger">*</span>
                    </Form.Label>
                    <Field
                      type="text"
                      className={`form-control input-form ${
                        errors.colombusAddress?.propertyNumber && "error"
                      }`}
                      name="colombusAddress.propertyNumber"
                    />
                    {errors.colombusAddress?.propertyNumber && (
                      <div className="invalid-feedback d-block">
                        {errors.colombusAddress?.propertyNumber}
                      </div>
                    )}
                  </Col>
                  <Col xs="12" md="6">
                    <Form.Group>
                      <Form.Label>
                        Peso (Kg) <span className="text-danger">*</span>
                      </Form.Label>
                      <Field
                        type="text"
                        className={`form-control input-form ${
                          errors.peso && "error"
                        }`}
                        name="peso"
                      />
                      {errors.peso && (
                        <div className="invalid-feedback d-block">
                          {errors.peso}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs="12" md="6">
                    <Form.Group>
                      <Form.Label>Talla (cm)</Form.Label>
                      <Field
                        type="text"
                        className={`form-control input-form ${
                          errors.talla && "error"
                        }`}
                        name="talla"
                      />
                      {errors.talla && (
                        <div className="invalid-feedback d-block">
                          {errors.talla}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs="12" md="12">
                    <Form.Group>
                      <Form.Label>Motivo consulta</Form.Label>
                      <Field
                        type="text"
                        className={`form-control input-form ${
                          errors.motivoConsulta && "error"
                        }`}
                        name="motivoConsulta"
                      />
                      {errors.motivoConsulta && (
                        <div className="invalid-feedback d-block">
                          {errors.motivoConsulta}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col className="text-right">
                    <Button
                      variant="outline-success"
                      className="ok-buttom"
                      type="submit"
                    >
                      Aceptar
                    </Button>{" "}
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
      <ComponentModalErrorSever
        show={showModalError}
        handleClose={handleCloseServer}
        error={errorServer}
      />
    </>
  );
}

export default withTranslation()(ComponentModalPacienteColombia);